import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@linaria/react';
import { showLocationOverlay } from 'modules/overlay/actions';
import { showOverlay } from 'modules/overlay/slice';
import { OverlayType } from 'modules/overlay/types';
import { getIsStreetViewEnabled } from 'utils/map';
import { Button } from '@daedalus/atlas/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { useInView } from '@daedalus/core/src/_web/utils/browser/hooks/useInView';
import { useDispatchTeamEvent } from '@daedalus/core/src/analytics/components/TeamContext';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { ContentHotel } from '@findhotel/sapi/dist/types/packages/core/src';
import { LocationAddress } from './LocationAddress';
import { StaticMapImage } from './StaticMap';
import { SelectedElement, TrackLocationClick } from './TrackLocationClick';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1ap6hub",
  propsAsIs: false
});
const LocationAddressWrapper = /*#__PURE__*/styled('div')({
  name: "LocationAddressWrapper",
  class: "luyilr6",
  propsAsIs: false
});
const MapBoxWrapper = /*#__PURE__*/styled('div')({
  name: "MapBoxWrapper",
  class: "m1xrnwlw",
  propsAsIs: false
});
const ButtonPositioner = /*#__PURE__*/styled('div')({
  name: "ButtonPositioner",
  class: "b10jiry",
  propsAsIs: false
});
const _exp16 = /*#__PURE__*/() => Text;
const LocationTitle = /*#__PURE__*/styled(_exp16())({
  name: "LocationTitle",
  class: "le7id52",
  propsAsIs: true
});
interface Props {
  hotel?: ContentHotel;
}
export const HotelLocationMap: React.FC<Props> = ({
  hotel
}) => {
  const {
    isMobile
  } = useDeviceLayout();
  const {
    lon,
    lat
  } = hotel?._geoloc || {};
  const dispatch = useDispatch();
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: true,
    threshold: 0.5
  });
  const dispatchTeamEvent = useDispatchTeamEvent();
  const isStreetViewEnabled = getIsStreetViewEnabled(hotel?.country);
  useEffect(() => {
    if (inView) {
      dispatchTeamEvent(trackEvent({
        category: Category.User,
        entity: Entity.HotelDetailsLocationSection,
        action: Action.Viewed
      }));
    }
  }, [dispatchTeamEvent, inView]);
  const handleClick = () => {
    dispatch(showLocationOverlay());
  };
  const handlePerson360Click = useCallback((event?: React.SyntheticEvent) => {
    event?.stopPropagation();
    if (hotel?.objectID) {
      dispatchTeamEvent(trackEvent({
        category: Category.User,
        entity: Entity.HotelDetailsStreetView,
        action: Action.Clicked,
        component: 'locationSection'
      }));
      dispatch(showOverlay({
        type: OverlayType.StreetView,
        params: {
          hotelId: hotel.objectID
        }
      }));
    }
  }, [hotel?.objectID, dispatch]);
  return <>
      {isMobile && <LocationTitle variant="titleL">
          <FormattedMessageWrapper id="location" defaultMessage="Location" />
        </LocationTitle>}
      <TrackLocationClick onClick={handleClick}>
        <Wrapper>
          <MapBoxWrapper ref={ref} data-id={SelectedElement.StaticMap}>
            <StaticMapImage lon={lon} lat={lat} />
            <ButtonPositioner data-id={SelectedElement.MapButton}>
              {isStreetViewEnabled && isMobile && <Button size="md" variant="secondary" isFloating iconStart={<Icon name={'Person360'} size="sm" colorPath="content.neutral.c950" />} onClick={handlePerson360Click} />}

              <Button size="md" variant="secondary" isFloating iconStart={<Icon name={'Maximize2'} size="sm" />}>
                <FormattedMessageWrapper id="openMap" defaultMessage="Open map" />
              </Button>
            </ButtonPositioner>
          </MapBoxWrapper>
          {isMobile ? <LocationAddressWrapper>
              <LocationAddress hotel={hotel} />
            </LocationAddressWrapper> : <Flex.Column>
              <LocationTitle variant="titleXL">
                <FormattedMessageWrapper id="location" defaultMessage="Location" />
              </LocationTitle>
              <LocationAddressWrapper>
                <LocationAddress hotel={hotel} />
              </LocationAddressWrapper>
            </Flex.Column>}
        </Wrapper>
      </TrackLocationClick>
    </>;
};

require("./HotelLocationMap.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HotelLocationMap.tsx");